import { render, staticRenderFns } from "./ItemsReceived.vue?vue&type=template&id=a697ad98&"
import script from "./ItemsReceived.vue?vue&type=script&lang=js&"
export * from "./ItemsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports